export default function LoanInformation() {
	return <>
		<h1>Loan Information</h1>
	</>
}
